import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { mockedAssignees } from '@hooks/mocks/assignees'
import { useFindProfile } from '@hooks/profile'
import { api } from '@services/apiClient'

interface IAssignees {
  alias: string
  crewSize: number
  description: string
  id: number
  resourceIds: number[]
  shiftHours: number
  supervisorId: number
  supervisorIds: number[]
}

export const useFindSiteAssignees = () => {
  const { data: user } = useFindProfile()
  const { isMockEnvironment } = useMockEnvironment()

  const siteId = user && user.selectedSite.id

  const fetchSiteAssignees = async () => {
    if (!isMockEnvironment) {
      const url = `sites/${siteId}/assignees`
      const { data } = await api.get<IAssignees[]>(url)
      return data
    }
    return mockedAssignees
  }
  return useQuery({ queryKey: ['ASSIGNEES'], queryFn: fetchSiteAssignees })
}
